var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6413 20.3809C12.4654 20.6839 12.2131 20.9355 11.9095 21.1104C11.6059 21.2853 11.2616 21.3773 10.9113 21.3773C10.5609 21.3773 10.2166 21.2853 9.91303 21.1104C9.60941 20.9355 9.35707 20.6839 9.18126 20.3809M16.9113 7.38086C16.9113 5.78956 16.2791 4.26344 15.1539 3.13822C14.0287 2.013 12.5026 1.38086 10.9113 1.38086C9.31996 1.38086 7.79383 2.013 6.66861 3.13822C5.5434 4.26344 4.91125 5.78956 4.91125 7.38086C4.91125 14.3809 1.91125 16.3809 1.91125 16.3809H19.9113C19.9113 16.3809 16.9113 14.3809 16.9113 7.38086Z",
    stroke: "#3068AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b8809890c1a8bac19ee5666be9a87e2f.svg";
export { ForwardRef as ReactComponent };